module.exports = __webpack_public_path__ + "static/white-wave-edb138cfb8e9eb07ef5f8d475d715911.png";